import Table from './Table'
import Th from './Th'
import Td from './Td'
import Tr from './Tr'

export { Table, Th, Td, Tr }



// WEBPACK FOOTER //
// ./src/Components/Stats/Table/index.js